// import React from 'react';
// import Papa from 'papaparse';
// import jsPDF from 'jspdf';
// import * as XLSX from 'xlsx';
// import { PiFileCsvLight, PiFilePdfLight, PiFileXlsLight } from 'react-icons/pi';

// const DownloadButton = ({ data, filename }) => {
//     const handleDownload = (format) => {
//         if (!data || data.length === 0) {
//             alert('No data available to download');
//             return;
//         }

//         if (format === 'csv') {
//             // Pivot the data for CSV
//             const metrics = [
//                 'Total Conversations',
//                 'Escalated to Human',
//                 'Tickets Created',
//                 'Abandoned Conversations',
//                 'Thumbs Up',
//                 'Thumbs Down',
//                 'Feedback Given',
//                 'Average Closure Time (min)'
//             ];

//             // Get unique dates
//             const dates = [...new Set(data.map(item => item.Date))].sort();

//             // Create pivoted data
//             const pivotedData = dates.map(date => {
//                 const row = { Date: date };
//                 metrics.forEach(metric => {
//                     const record = data.find(item => item.Date === date && item.Metric === metric);
//                     row[metric] = record ? record.Value : '';
//                 });
//                 return row;
//             });

//             // Convert to CSV
//             const csv = Papa.unparse(pivotedData, {
//                 columns: ['Date', ...metrics]
//             });
//             const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
//             const link = document.createElement('a');
//             link.href = URL.createObjectURL(blob);
//             link.download = `${filename}.csv`;
//             link.click();
//             URL.revokeObjectURL(link.href);
//         } else if (format === 'pdf') {
//             const doc = new jsPDF();
//             doc.setFontSize(12);
//             doc.text(`${filename.toUpperCase()} Report`, 10, 10);
//             let y = 20;

//             data.forEach((item, index) => {
//                 const text = typeof item === 'object' ? JSON.stringify(item, null, 2) : item.toString();
//                 const lines = doc.splitTextToSize(text, 180);
//                 doc.text(lines, 10, y);
//                 y += lines.length * 7;
//                 if (y > 270) {
//                     doc.addPage();
//                     y = 10;
//                 }
//             });

//             doc.save(`${filename}.pdf`);
//         } else if (format === 'xlsx') {
//             const ws = XLSX.utils.json_to_sheet(data);
//             const wb = XLSX.utils.book_new();
//             XLSX.utils.book_append_sheet(wb, ws, filename);
//             XLSX.writeFile(wb, `${filename}.xlsx`);
//         }
//     };

//     return (
//         <div className="flex justify-end gap-2">
//             <button
//                 onClick={() => handleDownload('csv')}
//                 className="bg-secondary flex items-center gap-3 text-sm text-primary hover:text-secondary border border-primary px-4 py-1 rounded hover:bg-primary transition"
//             >
//                 CSV
//                 {/* <PiFileCsvLight /> */}
//             </button>
//             <button
//                 onClick={() => handleDownload('pdf')}
//                 className="bg-secondary flex items-center gap-3 text-sm text-primary hover:text-secondary border border-primary px-4 py-1 rounded hover:bg-primary transition"
//             >
//                 PDF
//                 {/* <PiFilePdfLight /> */}
//             </button>
//             {/* <button
//                 onClick={() => handleDownload('xlsx')}
//                 className="bg-secondary flex items-center gap-3 text-sm text-primary hover:text-secondary border border-primary px-4 py-1 rounded hover:bg-primary transition"
//             >
//                 XLS
//             </button> */}
//         </div>
//     );
// };

// export default DownloadButton;



import React from 'react';
import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';

const DownloadButton = ({ data, filename }) => {
    const handleDownload = (format) => {
        if (!data || data.length === 0) {
            alert('No data available to download');
            return;
        }

        if (format === 'csv') {
            // Pivot the data for CSV (same logic as before)
            const metrics = [
                'Total Conversations',
                'Escalated to Human',
                'Tickets Created',
                'Abandoned Conversations',
                'Thumbs Up',
                'Thumbs Down',
                'Feedback Given',
                'Average Closure Time (min)'
            ];

            // Get unique dates
            const dates = [...new Set(data.map(item => item.Date))].sort();

            // Create pivoted data
            const pivotedData = dates.map(date => {
                const row = { Date: date };
                metrics.forEach(metric => {
                    const record = data.find(item => item.Date === date && item.Metric === metric);
                    row[metric] = record ? record.Value : '';
                });
                return row;
            });

            // === NEW: Convert to CSV using existing XLSX library (replaces PapaParse completely) ===
            // This uses json_to_sheet with explicit header order + sheet_to_csv for proper escaping/quoting
            const ws = XLSX.utils.json_to_sheet(pivotedData, {
                header: ['Date', ...metrics]
            });
            const csv = XLSX.utils.sheet_to_csv(ws);

            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `${filename}.csv`;
            link.click();
            URL.revokeObjectURL(link.href);
        } else if (format === 'pdf') {
            const doc = new jsPDF();
            doc.setFontSize(12);
            doc.text(`${filename.toUpperCase()} Report`, 10, 10);
            let y = 20;

            data.forEach((item, index) => {
                const text = typeof item === 'object' ? JSON.stringify(item, null, 2) : item.toString();
                const lines = doc.splitTextToSize(text, 180);
                doc.text(lines, 10, y);
                y += lines.length * 7;
                if (y > 270) {
                    doc.addPage();
                    y = 10;
                }
            });

            doc.save(`${filename}.pdf`);
        } else if (format === 'xlsx') {
            const ws = XLSX.utils.json_to_sheet(data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, filename);
            XLSX.writeFile(wb, `${filename}.xlsx`);
        }
    };

    return (
        <div className="flex justify-end gap-2">
            <button
                onClick={() => handleDownload('csv')}
                className="bg-secondary flex items-center gap-3 text-sm text-primary hover:text-secondary border border-primary px-4 py-1 rounded hover:bg-primary transition"
            >
                CSV
                {/* <PiFileCsvLight /> */}
            </button>
            <button
                onClick={() => handleDownload('pdf')}
                className="bg-secondary flex items-center gap-3 text-sm text-primary hover:text-secondary border border-primary px-4 py-1 rounded hover:bg-primary transition"
            >
                PDF
                {/* <PiFilePdfLight /> */}
            </button>
            {/* <button
                onClick={() => handleDownload('xlsx')}
                className="bg-secondary flex items-center gap-3 text-sm text-primary hover:text-secondary border border-primary px-4 py-1 rounded hover:bg-primary transition"
            >
                XLS
            </button> */}
        </div>
    );
};

export default DownloadButton;